module.exports = __webpack_public_path__ + "img/Mehrzweckboot.3001d5d5.svg";